import { ACCOUNT_BILLING_STATUS_MAP } from '@ubeya/shared/constants';

export const PAYMENT_PERIOD_TYPE_WEEK = 2;

export const ACCOUNT_PAYING_STATUSES = [
  ACCOUNT_BILLING_STATUS_MAP.INTERNAL,
  ACCOUNT_BILLING_STATUS_MAP.TRIAL,
  ACCOUNT_BILLING_STATUS_MAP.PAYING,
  ACCOUNT_BILLING_STATUS_MAP.DEMO,
  ACCOUNT_BILLING_STATUS_MAP.WARNING
];

export const TabTypes = {
  FINANCIALS: 'financials',
  BRANCHES: 'branches',
  SETTINGS: 'settings',
  CONTACTS: 'contacts',
  RATES: 'rates',
  ORDERS: 'orders',
  LOCATIONS: 'locations',
  COMMENTS: 'comments',
  AWR: 'awr',
  INVOICES: 'invoices',
  CLIENT_COST_CENTERS: 'clientCostCenters'
};
